function MediaFigure({ src, alt, caption, enhanced = false, compact = false }) {
  const figureClass = [
    'MediaFigure',
    enhanced ? 'MediaFigure--enhanced' : '',
    compact ? 'MediaFigure--compact' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <figure className={figureClass}>
      <div className={enhanced ? 'EnhancedImage-frame' : 'MediaFigure-frame'}>
        <img
          src={src}
          alt={alt}
          className={enhanced ? 'EnhancedImage' : 'MediaFigure-image'}
        />
      </div>
      {caption ? (
        <figcaption className="MediaFigure-caption">{caption}</figcaption>
      ) : null}
    </figure>
  );
}

export default MediaFigure;
